export default "__VITE_ASSET__BOLuOVkF__"